import {
  Badge,
  Card,
  Group,
  Loader,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useQuery } from "@apollo/client/react";
import { graphql } from "gql.tada";
import { useParams } from "react-router-dom";
import { IconInfoCircle, IconTournament } from "@tabler/icons-react";

const WebhookQuery = graphql(`
  query webhookDashboard($id: ID!) {
    webhook(id: $id) {
      id
      description
      events
      url
      active
    }
  }
`);

export const WebhookHome = () => {
  const webhookId = useParams().webhookId ?? "";
  const { data, loading } = useQuery<any>(WebhookQuery, {
    variables: {
      id: webhookId,
    },
  });

  if (loading) {
    return <Loader />;
  }

  return (
    <Stack gap={0}>
      <Title>Webhook - {data?.webhook.url}</Title>
      <SimpleGrid cols={2}>
        <Card>
          <Card.Section>
            <Group justify="space-between" p={10}>
              <Group gap={10}>
                <IconTournament />
                <Text size="md" fw={700}>
                  General
                </Text>
              </Group>
              <Badge color={data?.webhook.active ? "green" : "red"}>
                {data?.webhook.active ? "Enabled" : "Disabled"}
              </Badge>
            </Group>
          </Card.Section>
          <Text>{data?.webhook.description}</Text>
          <Text fw={700}>Events</Text>
          <Group gap={0}>
            {data?.webhook.events.map((event: string) => (
              <Badge key={event}>{event}</Badge>
            ))}
          </Group>
        </Card>
        <Card>
          <Card.Section>
            <Group justify="space-between" p={10}>
              <Group gap={10}>
                <IconInfoCircle />
                <Text size="md" fw={700}>
                  Last errors
                </Text>
              </Group>
            </Group>
          </Card.Section>
          <Text size="sm" c="dimmed">
            Webhook delivery errors are migrating to the unified Journal
            system. They will reappear here once the webhook emitters
            are connected to the Journal API.
          </Text>
        </Card>
      </SimpleGrid>
    </Stack>
  );
};
